import { Chip } from "@mui/material";

export const getStatusColor = (status) => {
  const statusLower = status?.toLowerCase() || "";

  if (statusLower.includes("drop") || statusLower.includes("depot") || statusLower.includes("depo")) {
    return { bgcolor: "#04384d", color: "#fff" };
  }
  if (statusLower.includes("queue")) {
    return statusLower.includes("waiting")
      ? { bgcolor: "#9E9E9E", color: "#fff" }
      : { bgcolor: "#1E3A8A", color: "#fff" };
  }
  if (statusLower.includes("waiting")) {
    return { bgcolor: "#9E9E9E", color: "#fff" };
  }

  if (statusLower.includes("progress")) {
    return { bgcolor: "#2196F3", color: "#fff" }; // Blue
  }
  if (statusLower.includes("paused")) {
    return { bgcolor: "#FF9800", color: "#fff" }; // Orange
  }
  if (statusLower.includes("canceled")) {
    return { bgcolor: "#F44336", color: "#fff" }; // Red
  }
  if (statusLower.includes("unload")) {
    return { bgcolor: "#9C27B0", color: "#fff" }; // Purple
  }
  if (statusLower.includes("ready") || statusLower.includes("loaded")) {
    return { bgcolor: "#00BCD4", color: "#fff" }; // Cyan
  }
  if (statusLower.includes("transit")) {
    return { bgcolor: "#3F51B5", color: "#fff" }; // Indigo
  }
  if (statusLower.includes("delivered")) {
    return { bgcolor: "#4CAF50", color: "#fff" }; // Green
  }

  return { bgcolor: "#9E9E9E", color: "#fff" }; // Gray for unknown
};

export const getOrderLinesColumns = (hasCanceledLines) => {
  const baseColumns = [
    {
      field: "stock_code",
      headerName: "Stock Code",
      flex: 1,
      minWidth: 130,
      sortable: false,
    },
    {
      field: "stock_description",
      headerName: "Description",
      flex: 2,
      minWidth: 250,
      sortable: false,
    },
    {
      field: "order_qty",
      headerName: "Order Qty",
      flex: 1,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "stock_on_hand",
      headerName: "Stock On Hand",
      flex: 1,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },

  
  ];

  if (hasCanceledLines) {
    baseColumns.push({
      field: "line_state",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        if (params.value === "canceled") {
          return (
            <Chip
              label="Canceled"
              size="small"
              sx={{
                bgcolor: "#F44336",
                color: "#fff",
                fontWeight: 500,
                fontSize: "12px",
              }}
            />
          );
        }
        return null;
      },
    });
  }
  baseColumns.push({
    field: "delivery_order_line_remarks",
    headerName: "Remarks",
    flex: 1,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
    sortable: false,
  });

  return baseColumns;
};
